












import { defineComponent } from '@nuxtjs/composition-api';
import UCProductHeroSection from '@shared/components/@atoms/UCProductHeroSection/UCProductHeroSection.vue';
import UCSkeletonShimmer from '@shared/components/@atoms/UCSkeletonShimmer/UCSkeletonShimmer.vue';

export default defineComponent({
  name: 'UCProductContact',
  components: { UCProductHeroSection, UCSkeletonShimmer },
  props: {
    headingText: {
      type: String,
      default: 'Got Questions?',
    },
    descriptionText: {
      type: String,
      default: 'We are here to help.',
    },
    link: {
      type: String,
      default: '/pages/contact',
    },
    linkText: {
      type: String,
      default: 'Contact Us',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
